<template>
    <div>
        <div v-html="content"></div>
    </div>
</template>

<script>
import marked from 'marked';
import useMarkedImgRenderer from '@/config/marked-config';
import contentCache from '@/util/content-cache';
import titleLookup from '@/util/title-lookup';

export default {
    title() {
        return (titleLookup && titleLookup[this.$route.path]) || "Image Me Souvenir Photography"
    },
    name: 'ContentResolver',
    data: function() {
        return {
            content: null,
            publicPath: process.env.BASE_URL,
            back: null
        }
    },
    props: {
        contentSlug: String,
    },
    created: function() {
        useMarkedImgRenderer();
        this.getContent();
    },
    watch: {
        $route(to, from) {
            this.getContent(to,from);
        }
    },
    methods: {
        getContent: function(to,from) {
            this.content = null;
            this.back = from;
            let path = '';
            if (!to) {
                path = `${this.publicPath}Pages${this.$route.path}/`;
            } else {
                path = `/Pages${to.path}/`;
            }
            if (this.contentSlug) {
                path += `${this.contentSlug}.md`;
            } else {
                path += 'index.md';
            }
            const cached = contentCache.readCache(path);
            if (cached) {
                this.content = marked(cached);
                return;
            }

            this.$http.get(path).then((response) => {
                this.content = marked(response.data);
                contentCache.writeCache(path, response.data);
            });
        }
    }
}
</script>